import Link from "next/link";
import { Button, ButtonProps } from "../ui/button";
import { cn } from "@/lib/utils";
import { HTMLAttributeAnchorTarget } from "react";

export const NavButton = ({
  href,
  linkTarget,
  className,
  ...buttonProps
}: ButtonProps & {
  linkTarget?: HTMLAttributeAnchorTarget;
  href?: string | null;
}) => {
  if (!href) return <Button {...buttonProps} />;

  return (
    <Link
      href={href}
      prefetch
      className={cn(className, "mx-auto w-full no-underline")}
      target={linkTarget}
    >
      <Button {...buttonProps} />
    </Link>
  );
};
